import styled from 'styled-components'
import { DialogContent as NatDsDialogContent } from '@/main/components/dialog'

export const DialogContent = styled(NatDsDialogContent)`
  max-height: 50vh;
  padding: 0.8rem 0;
  border-top: 0.1rem solid ${({ theme }) => theme.color.lowEmphasis};
  border-bottom: 0.1rem solid ${({ theme }) => theme.color.lowEmphasis};
`
